export const formConfig = [
  {
    name: 'name',
    placeholder: 'Search by Name/Surname',
  },
  {
    name: 'country',
    placeholder: 'Select country',
  },
];

export const initialState = {
  name: '',
  country: '',
  class: '',
};
